import { AbstractEntityMapper } from '@pf/shared-services';
import {
    InventoryAdjustmentCreate,
    InventoryAdjustmentDto,
    InventoryAdjustmentRead,
    InventoryAdjustmentSearchParams,
} from '../../entities/inventory-adjustment.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { InventoryAdjustmentMetadataMap } from './inventory-adjustment.mapping-profile';

@Injectable()
export class InventoryAdjustmentMapper extends AbstractEntityMapper<
    InventoryAdjustmentRead,
    InventoryAdjustmentCreate,
    InventoryAdjustmentDto,
    InventoryAdjustmentSearchParams
> {
    constructor() {
        super(
            InventoryAdjustmentDto,
            PlatformWmsMapper,
            InventoryAdjustmentMetadataMap.symbols
        );
    }
}
